<app-frame [frameSrc]="url" id="ONBGS"></app-frame>
